export default __webpack_public_path__ + "static/media/upload.f5be950f.png";